// extracted by mini-css-extract-plugin
export default {"container":"ConfigSeparator_container__QG17E"};